
// src/web/components/diary-timestamp.jsx

import React from 'react'
import { themr } from 'react-css-themr'
import { translate } from 'react-i18next'
import moment from 'moment'
import diaryTheme from './themes/diary.css'
import Tooltip from 'react-toolbox/lib/tooltip'
import {
  Button,
} from 'react-toolbox/lib/button'

const TooltipButton = Tooltip(Button)

@themr('Diary', diaryTheme)
class DiaryTimestamp extends React.Component {
  state = { update: undefined }
  setTimer = (timestamp)=> {
    var interval
    var elapsed = moment().diff(moment(timestamp), 'seconds')
    this.timer && clearInterval(this.timer)
    if (elapsed < 60) // 1分未満
      interval = 30 // 30秒ごと
    else if (elapsed < 10 * 60) // 10分未満
      interval = 2 * 60 // 2分ごと
    else if (elapsed < 60 * 60) // 1時間未満
      interval = 10 * 60 // 10分ごと
    else if (elapsed < 24 * 60 * 60) // 24時間未満
      return
    else // それ以降
      return
    this.timer = setInterval(this.update, interval * 1000)
  }
  
  update = ()=> {
    this.setState({ update: new Date() })
  }

  componentDidMount() {
    this.setTimer(this.props.timestamp)
  }

  componentWillUnmount() {
    this.timer && clearInterval(this.timer)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setTimer(nextProps.timestamp)
  }

  render() {
    const {
      t,
      timestamp,
      updated,
      theme,
    } = this.props

    const edited = updated && !moment(timestamp).isSame(updated, 'minutes')
    const is_pastDay = moment().diff(moment(timestamp), 'second') > 24 * 60 * 60
    const is_pastYear = moment().diff(moment(timestamp), 'years') >= 1

    return (
      <TooltipButton neutral={false} ripple={false}
          theme={theme} className="touchable"
          tooltip={
            <div>
              <div>{moment(timestamp).format('LLLL HH:mm')}</div>
              {edited && <div>{t('label:編集時刻', { updated: moment(updated).format('LLLL HH:mm') })}</div>}
            </div>
          }
          tooltipPosition="bottom" 
          label={t('format:timestamp',{ timestamp }) + (edited && t('label:編集済み') || '')} />
    )
  }
}

export default translate()(DiaryTimestamp)



// WEBPACK FOOTER //
// ./src/web/components/diary-timestamp.jsx